// src/components/VisionMission.js
import React from "react";
import "./VisionMission.css"; // External CSS जोडले

const VisionMission = () => {
  return (
    <div className="vision-mission-container">
      <h1 className="title">Our Vision & Mission</h1>

      <div className="vision-section">
        <h2>🌍 Our Vision</h2>
        <p>
          To be recognized as a <strong>global leader in ISO certification</strong> and quality management
          systems — empowering businesses worldwide to achieve operational excellence,
          sustainable growth, and customer trust through continuous improvement.
        </p>
      </div>

      <div className="mission-section">
        <h2>🎯 Our Mission</h2>
        <p>
          Our mission is to provide <strong>transparent, reliable, and professional certification services</strong>
          that help organizations meet international standards, enhance credibility,
          and foster a culture of quality, safety, and environmental responsibility.
        </p>
      </div>
    </div>
  );
};

export default VisionMission;
